var _line, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMinusPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_2144",
    "data-name": "Group 2144",
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    id: "Line_117",
    "data-name": "Line 117",
    x2: 12,
    transform: "translate(3 9)",
    fill: "none",
    stroke: "#1450ff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_674",
    "data-name": "Rectangle 674",
    width: 18,
    height: 18,
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinusPrimaryIcon);
export default __webpack_public_path__ + "static/media/minus-primary-icon.048940493c820310a2d83683dc004c59.svg";
export { ForwardRef as ReactComponent };